import React from 'react'
import { Field } from 'redux-form'
import Button from 'components/Shared/Button'
import SettingsFormField from 'components/Shared/Forms/SettingsFormField'

const CouponInput = ({ couponVisible, showCoupon, getCoupon, hideCoupon }) => {
  if (hideCoupon) {
    return null
  }

  if (couponVisible) {
    return (
      <div className="input-padding">
        <Field
          small
          autoFocus
          label="Discount Code"
          name="coupon"
          component={SettingsFormField}
        />
        <Button
          className="team-settings-form-button"
          type="button"
          onClick={getCoupon}
        >
          Apply
        </Button>
      </div>
    )
  }

  return (
    <a className="coupon-code-link" onClick={showCoupon}>
      Have a Discount Code?
    </a>
  )
}

const CouponSection = ({
  couponVisible,
  couponSuccess,
  couponError,
  isRegionalDiscount,
  showCoupon,
  getCoupon,
  hideCoupon,
}) => {
  return (
    <div className="clear-left">
      <CouponInput
        couponVisible={couponVisible}
        showCoupon={showCoupon}
        getCoupon={getCoupon}
        hideCoupon={hideCoupon}
      />
      {couponError ? (
        <div className="coupon-code-error">{couponError}</div>
      ) : null}
      {couponSuccess ? (
        <div className="coupon-code-success">
          {isRegionalDiscount
            ? 'Regional Discount Applied!'
            : 'Discount Applied!'}
        </div>
      ) : null}
    </div>
  )
}

export default CouponSection
